import { services } from "../../../api";
import { NewsItem, Tab } from "../../../interfaces/api/congresses";

/**
 * Get news details by ID
 * @param {number} id - The ID of the news item to fetch
 * @returns {Promise<NewsItem | null>} News item details, returns null on error
 */
export const getNewsDetails = async (id: number): Promise<null | NewsItem> => {
  try {
    const res = await services.tabs.getNewsDetails(id);
    if (res.result !== "success") {
      throw new Error("error");
    }
    return res.content;
  } catch (ex) {
    return null;
  }
};

export const getNews = async (
  tab_id: number,
  pageSize: number,
  page: number,
  filters: Record<string, any>,
) => {
  try {
    const res = await services.tabs.getNews({
      pageSize,
      page,
      tab_id,
      ...filters,
    });
    return res;
  } catch (ex) {
    // Optionally handle/log the error
    return null;
  }
};
